<template>
  <settings-modal
    hide-container
    class="t-remove-countries-modal"
  >
    <div
      slot="heading"
      class="font-weight-bold"
    >{{ modalTitle }}</div>

    <ul
      v-for="removedCountry in removedCountries"
      :key="removedCountry"
    >
      <li>{{ getCountryName(removedCountry) }} ({{ removedCountry }})</li>
    </ul>

    <template slot="actions">
      <v-btn
        class="t-save-countries"
        color="primary"
        medium
        flat
        :disabled="isLoading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        :disabled="isLoading"
        @click="onCloseButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import flashMessages from '@/mixins/flashMessages'
  import countries from '@/mixins/countries'
  import SettingsModal from '@/components/modals/SettingsModal'

  export default {
    name: 'CountryGroupsRemoveModal',
    components: { SettingsModal },
    mixins: [countries, flashMessages],
    data () {
      return {
        isLoading: false
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      modalTitle () {
        return this.modal.data.title != null ? this.modal.data.title : `Remove from "${this.group.name}"`
      },
      group () {
        return this.modal.data.group
      },
      removedCountries () {
        return this.modal.data.removedCountries
      },
      updateCountryGroup () {
        return this.modal.data.updateCountryGroup
      }
    },
    methods: {
      ...mapActions('modal', ['closeModal']),
      onConfirmButtonClick () {
        const countries = this.group.countryCodes.filter((countryCode) => !this.removedCountries.includes(countryCode))

        this.setIsLoading(true)
        this.updateCountryGroup(this.group.id, countries)
          .then(() => this.showSuccessFlashMessage('Country group has been successfully updated.'))
          .catch(() => this.showErrorFlashMessage('Country group has not been updated.'))
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      setIsLoading (isLoading) {
        this.$set(this, 'isLoading', isLoading)
      }
    }
  }
</script>
